// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { useUserInputAsSelect } from '@tectonics/prs/user-input-values';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useUserInputValidationError, type UserInputValidationError } from '@tectonics/prs/validation';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { getSafeEftPaymentOption } from '@tectonics/prs/incoming-payment/payment-option';
import {
  useOpenedIncomingPayment,
} from '@tectonics/prs/incoming-payment';

import { Country } from '@ebanx/ebanx-js';
import { Field } from '../../../molecules';
import { Select, SelectOption, Label } from '../../../atoms';
import { SimpleTextErrorMessage } from '@tectonics/look-and-feel/commons/validation-error-message';
import { getSafePaymentOptionsV2 } from '@tectonics/prs/incoming-payment/get-payment-options';

export function BankList(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const [value, handleChange] = useUserInputAsSelect('selectedEftBank');
  const submitting = useSubmitting();

  const validationError = useUserInputValidationError('selectedEftBank');
  const formHasBeenSent = useFormHasBeenSent();

  const paymentOptions = getSafePaymentOptionsV2(incomingPayment);
  const bankList = getSafeEftPaymentOption(paymentOptions);

  const inputId = useUniqueId();

  return (
    <Field
      size="half"
      label={<Label htmlFor={inputId}>Banco</Label>}
      showFloatingLabel
      data-test-name="payment-type-code"
      error={<SimpleTextErrorMessage getMessage={getMessage} validationError={validationError} />}
      hasError={formHasBeenSent && !!validationError}
    >
      <Select
        id={inputId}
        value={value}
        onChange={handleChange}
        readOnly={submitting}
        name="payment-type-code"
      >
        <SelectOption value="">Selecciona tu banco</SelectOption>

        {bankList.map(({ name, value }) => {
          return (
            <SelectOption key={name} value={value}>
              {name}
            </SelectOption>
          );
        })}
      </Select>
    </Field>
  );
}

function getMessage(validationError: UserInputValidationError, country: Country): ?string {
  switch (validationError.id) {
    case 'empty':
      return 'Seleccione el banco';
    default:
      return 'Banco inválido';
  }
}
